export enum ReportStatuses {
  downloaded = 'DOWNLOADED',
  emailed = 'EMAILED',
  printed = 'PRINTED',
}
